import {
  initTracerError,
  initTracerErrorUploader,
  initTracerLog,
  initTracerSessionUploader,
  initTracerWebVitals,
  initTracerWebVitalsUploader,
} from '@tracer/sdk';

import filterError from './filterError';
import writeConsoleToLog from './writeConsoleToLog';

const config = {
  versionName: process.env.TRACER_VERSION_NAME,
  versionCode: Number.parseInt(process.env.TRACER_VERSION_CODE),
  appToken: process.env.TRACER_APP_TOKEN,
};

const tracer = initTracerError({filterError});

tracer.setErrorKey('pathname', window.location.pathname);

initTracerErrorUploader(config);
initTracerSessionUploader(config);

initTracerWebVitals({
  addMetricAttributes: () => ({pathname: location.pathname}),
});

initTracerWebVitalsUploader(config);

if (typeof window._tracer_module === 'string') {
  tracer.setModule(window._tracer_module);
}

const logger = initTracerLog();

writeConsoleToLog(logger);
